(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-index"] && !Shopify.designMode) return;
  try {
    
  function preloader() {
    const preloader = document.querySelector('.preloader__inner');
    let video = document.querySelector('.main-home__video--mobile');
    if (window.innerWidth > 990) {
      video = document.querySelector('.main-home__video--desktop');
    }
    preloader.addEventListener('animationend', function () {
      setTimeout(() => {
        preloader.parentElement.setAttribute('data-aos', 'fade-out');
        video.play();
      }, 900);
    });
    preloader.parentElement.addEventListener('transitionend', function (e) {
      e.target.remove();
    });
  }
  preloader();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
	function initTestimonialSlider() {
		const testimonialSlider = new Swiper('.testimonial-slider .swiper-container', {
			loop: true,
			autoplay: {
				delay: 6000
			},
			slidesPerView: 'auto',
			spaceBetween: 0,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			}
		});
		console.log(testimonialSlider)
	}		

	document.addEventListener('DOMContentLoaded', function() {
		initTestimonialSlider();
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-project-details-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const bgVideo = document.querySelector('.project-details-header__video-bg video');
    const fgVideo = document.querySelector('.project-details-header__video-foreground video');

    console.log('Project details header videos:', { bgVideo, fgVideo });

    if (bgVideo && fgVideo) {
      let bgReady = false;
      let fgReady = false;
      let syncAttempted = false;

      function synchronizeAndPlay() {
        if (bgReady && fgReady && !syncAttempted) {
          syncAttempted = true;
          console.log('Attempting to synchronize videos...');

          // Reset both videos to start
          bgVideo.currentTime = 0;
          fgVideo.currentTime = 0;

          // Since autoplay is enabled, check if they're already playing
          if (!bgVideo.paused || !fgVideo.paused) {
            console.log('Videos are already playing, synchronizing...');
            // Pause both first to resync
            bgVideo.pause();
            fgVideo.pause();
          }

          // Small delay then play both simultaneously
          setTimeout(() => {
            Promise.all([bgVideo.play(), fgVideo.play()])
              .then(() => {
                console.log('✅ Videos synchronized and playing');
                bgVideo.setAttribute('data-sync-video', 'true');
                fgVideo.setAttribute('data-sync-video', 'true');
              })
              .catch((error) => {
                console.log('❌ Video play failed:', error);
                // Reset flag to allow retry
                syncAttempted = false;
              });
          }, 50);
        }
      }

      // Wait for both videos to be ready
      bgVideo.addEventListener('loadeddata', function () {
        console.log('Background video loaded');
        bgReady = true;
        synchronizeAndPlay();
      });

      fgVideo.addEventListener('loadeddata', function () {
        console.log('Foreground video loaded');
        fgReady = true;
        synchronizeAndPlay();
      });

      // Fallback: also try on canplaythrough
      bgVideo.addEventListener('canplaythrough', function () {
        if (!bgReady) {
          console.log('Background video can play through');
          bgReady = true;
          synchronizeAndPlay();
        }
      });

      fgVideo.addEventListener('canplaythrough', function () {
        if (!fgReady) {
          console.log('Foreground video can play through');
          fgReady = true;
          synchronizeAndPlay();
        }
      });

      // Handle external pause (like pauseAllMedia) and restart
      function handlePauseAndRestart() {
        if (bgVideo.paused && fgVideo.paused && syncAttempted) {
          console.log('Videos were paused externally, restarting...');
          setTimeout(() => {
            if (bgVideo.paused && fgVideo.paused) {
              bgVideo.currentTime = 0;
              fgVideo.currentTime = 0;
              Promise.all([bgVideo.play(), fgVideo.play()]).catch(console.log);
            }
          }, 100);
        }
      }

      bgVideo.addEventListener('pause', handlePauseAndRestart);
      fgVideo.addEventListener('pause', handlePauseAndRestart);
    } else {
      console.log('❌ Could not find both videos');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
